import './RoundSmolButton.css';

const RoundSmolButton = ({ onClick, enabled, disabled, title, children }) => {
  return (
    <button
      className={`round-smol-button${enabled ? '' : ' disabled'}`}
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export { RoundSmolButton };
